/*! LHL Size Tool build 11b256b183ab - generated by scripts/build_widget.py from widget/copy.js + widget/widget.js. DO NOT EDIT THIS FILE - edit widget/ and rebuild. */
(function () {
var module;
(typeof self !== "undefined" ? self : this).LHL_BUILD = "11b256b183ab";

/**
 * LHL Size Tool — copy module.
 *
 * EVERY customer-facing string lives here and NOWHERE else. This file
 * mirrors docs/LHL_Size_Tool_Copy_Set.md section by section — that file is
 * the single source; edit copy there first, then reflect it here verbatim.
 * Flow logic (widget.js) must never contain literal customer-facing text.
 *
 * House rules: Australian English, no fluff, and NO em-dashes in any
 * customer-facing string (rewritten with commas/full stops).
 *
 * Placeholders use the Copy Set's own tokens: [Brand], [Model],
 * [Brand Model], [Size], [First name]. Use formatCopy() to fill them.
 */

/* eslint-disable quotes */
(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.LHL_COPY = factory();
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var COPY = {
    // §1 Welcome / hero
    welcome: {
      heading: "Find your perfect fit in under 30 seconds.",
      sub: "No tape measure required.",
      button: "Find your fit",
    },

    // §2 Step 1 — Brand (no helper line; no escape link at flow start)
    stepBrand: {
      heading: "Tell us your brand or model of bassinet, co-sleeper or cot.",
      placeholder: "Start typing your brand…",
    },

    // §3 Step 2 — Model (helper line removed 2026-07-09)
    stepModel: {
      heading: "Do you know the model name?",
      placeholder: "Start typing your model…",
      // §20 Cross-brand "did you mean" prompt (in-brand miss only).
      didYouMean: "We don't have that one under [Brand]. Did you mean:",
    },

    // §4 Email step — new visitor (privacy explainer sits BELOW the button;
    // the §13 safety acknowledgement lives on this step too).
    emailNew: {
      heading: "One last step. Where should we send your fit?",
      firstNameLabel: "First name",
      firstNamePlaceholder: "Name",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      emailError: "Please enter your email",
      button: "Show my fit",
      bodyUnderButton: "This does not opt you into marketing consent. We will only send you a copy of your recommended size and keep a record for sizing support or exchanges.",
      // Same-session repeat lookup: email field skipped, disclosed with a
      // change option (the §13 safety tick is still required).
      reuseNotice: "Sending your result to [Email].",
      reuseChangeLink: "Not you? Change",
    },

    // §5 Email step — known visitor, escalation only (future known-user skip)
    emailKnownEscalation: {
      heading: "Quick one. What's the best email to reach you on?",
      body: "We don't have this one on file yet, so we'll look it up and reply personally. Pop in your email and we'll come straight back.",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      button: "Send my enquiry",
    },

    // §6 Result — MATCH (PDP, right size)  [kept for PDP placement later]
    matchPdpRight: {
      statement: "You'll need our [Size] sheet to fit your [Brand Model].",
      button: "Add this one to my cart",
      flourish: "The hardest decision left is which colour.",
    },

    // §7 Result — MATCH (PDP, wrong size). Cards use the §21 label/add link.
    // The count-aware favourites sentence renders "[Size] Collection" as an
    // olive inline link to the RECOMMENDED size's collection.
    matchPdpWrong: {
      statement: "Heads up, you'll need our [Size] sheet to fit your [Brand Model].",
      favouritesTwo: "Here is a couple of favourites in your correct size, or you can browse the full [Size] Collection.",
      favouritesOne: "Here is a favourite in your correct size, or you can browse the full [Size] Collection.",
      collectionLink: "Shop our [Size] sheets",
    },

    // §8 Result — MATCH (Discovery). [Size] is the DISPLAY name (see
    // sizeDisplay below). The collection link renders normal weight, not bold.
    matchDiscovery: {
      statement: "You'll need our [Size] sheet to fit your [Brand Model].",
      // The reassurance line itself is DATA-DRIVEN (the row's fit_copy from
      // the sheet, via the API) — this is only the safety-net fallback.
      reassuranceFallback: "A snug, secure fit for your setup.",
      subRecentlyViewed: "A couple you've had your eye on, in your size:",
      subBestSellers: "A couple of favourites in your size:",
      seeAllLink: "See the [Size] collection",
      flourish: "Sizing? Sorted. Now let's choose your colour combo!",
    },

    // §9 Result — DOESN'T FIT (terminal)
    doesntFit: {
      statement: "We've had a proper look, and honestly, none of our sheets are the right fit for the [Brand Model].",
      reassurance: "We'd rather tell you straight than sell you a sheet that doesn't sit properly. A sheet that fits snugly matters. If your setup changes, or you think we've got this wrong, we're one message away.",
      link: "Talk to us",
    },

    // §10 Result — KNOWN-PENDING (escalation)
    pending: {
      statement: "We've got the [Brand Model] on our list. We just want to confirm the exact fit before we point you to a sheet.",
      reassurance: "Leave it with us. We'll confirm your size and email you as soon as we can.",
      micro: "No need to do anything. It's with our team.",
    },

    // §11 Result — NOT FOUND (escalation)
    notFound: {
      statement: "We don't have the [Brand Model] in our guide just yet.",
      reassurance: "Rather than guess, we'll look it up properly and email you the right size as soon as we can.",
      micro: "One of the team will be in touch. You're sorted.",
    },

    // §12 Kids sheets — out of scope (restocking)
    kids: {
      statement: "Our Kids sheets are between runs right now.",
      reassurance: "They'll be back. For anything else, our team's happy to help.",
      link: "Talk to us",
    },

    // §13 Safety acknowledgement — REQUIRED tick on the email-capture step,
    // before any result, for every outcome and identity.
    safetyAck: {
      label: "I understand this is a guide only. It doesn't replace current safe-sleep advice or my own judgement.",
      nudge: "Just tick the box above so we know you've read this, and you're good to go.",
    },

    // §14 Error / tool unavailable
    error: {
      statement: "Hmm. Our size finder's having a moment.",
      reassurance: "Give it another go, or send us your cot's brand and model and we'll sort your size by hand.",
      retryButton: "Try again",
      contactButton: "Message us",
    },

    // §15 Micro-copy & states (escape hatch retired; escalation link is §18)
    micro: {
      loadingLookup: "Finding your fit…",     // normal size lookups ONLY
      loadingEscalation: "Just a moment…",    // escalation form submits ONLY
      loadingCart: "Adding to your cart…",
      addedToCart: "Added. It's in your cart.",
      typeaheadEmpty: "Searching for a match…",
      backLink: "Start again",
    },

    // §19 Size display names — DISPLAY-ONLY mapping from the five canonical
    // DB Type values to customer-facing text ("/ Change Pad" dropped).
    // Canonical values, matching and audit stay untouched.
    sizeDisplay: {
      "Small Bassinet": "Small Bassinet",
      "Co-Sleeper / Change Pad": "Co-Sleeper",
      "Mini Cot": "Mini Cot",
      "Standard Cot": "Standard Cot",
      "European Cot": "European Cot",
    },

    // §17 Brand rename acknowledgement (Seena ⇄ Tasman Eco)
    brandRename: {
      FORMERLY_TASMAN_ECO: "Quick note: Seena used to be called Tasman Eco. Same maker, new name. Your model is in our guide under the old one.",
      NOW_SEENA: "Quick note: Tasman Eco goes by Seena these days. Same maker, new name. Your model is in our guide under the new one.",
    },

    // §21 PDP entry row & product-card microformat. The tab label renders
    // uppercase via CSS (text-transform), so the string stays sentence case.
    pdpEntry: {
      label: "Find your fit",
    },
    cards: {
      // Card layout: §19 display size + right-justified price on one line,
      // colour_name beneath in a lighter weight (see Copy Set §21).
      addLink: "Add to cart +",     // text link, uppercased by CSS
    },

    // §18 Escalation link + form (the ONE escalation link; conditional —
    // appears only after an empty/weak search, then stays for the session)
    escalation: {
      link: "Can't find yours? Ask us!",
      heading: "Can't find yours? We'll find it for you.",
      body: "Share the brand, model, a product link or any other details you have and we'll get a real human to check and get back to you.",
      firstNameLabel: "First name (optional)",
      firstNamePlaceholder: "Name",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      descriptionLabel: "Your cot or bassinet",
      descriptionPlaceholder: "e.g. brand, model, or a product link",
      emailError: "Please enter your email",
      descriptionError: "Can you tell us the brand name or model of bassinet or cot you need to fit? A link to the product also works.",
      button: "Submit",
      confirmedHeading: "Done. It's with our team.",
      confirmedBody: "We'll track down the right size and email you as soon as we can.",
      confirmedMicro: "No need to do anything else. You're sorted.",
    },
  };

  /** Replace Copy Set tokens: formatCopy("your [Brand Model]", {"Brand Model": "Boori Sleigh"}) */
  function formatCopy(template, values) {
    var out = template;
    Object.keys(values || {}).forEach(function (key) {
      out = out.split("[" + key + "]").join(values[key]);
    });
    return out;
  }

  return { COPY: COPY, formatCopy: formatCopy };
});

/**
 * LHL Size Tool — embeddable widget (vanilla JS, no framework).
 *
 * Talks ONLY to the lookup API (/v1/search, /v1/models, /v1/confirm,
 * /v1/escalate) — no matching or size logic lives in the browser, ever. All
 * customer-facing text comes from copy.js (mirrors LHL_Size_Tool_Copy_Set.md).
 *
 * Escalations (both raise a Gorgias ticket server-side via /v1/escalate):
 *   NOT_FOUND — the §18 free-text form: first_name + email + one description
 *               box. Success shows §11; a 503 shows §14.
 *   PENDING   — a confirmed known-pending lookup (real brand+model tapped,
 *               size blank). No free-text box: the ticket fires automatically
 *               with the identity the flow already holds, then §10 renders.
 *               A 503 shows §14. The lookup's own §10 screen is never shown
 *               without the ticket having been raised (or audited server-side
 *               if Gorgias is down — the API degrades, never errors, for a
 *               Gorgias outage).
 *
 * Structure (all in this one bundle, separated by concern):
 *   createApiClient(config)  — fetch wrapper with timeout, never hangs
 *   createFlow(deps)         — DOM-free state machine (unit-tested in Node)
 *   render/mount             — thin DOM layer driven by flow state
 *
 * Embed later in the Shopify theme:
 *   LHLSizeTool.mount(document.querySelector('#lhl-size-tool'), { ... });
 * PDP embeds set placement: "pdp" and a data-product-handle attribute on the
 * mount element (display-routing context only — never a size-decision input).
 *
 * Enrichment (MATCH results): the API returns collection routing + up to two
 * curated in-stock cards (app/enrichment.py). Add-to-cart uses Shopify's
 * native /cart/add.js with the card's server-parsed numeric variant id.
 *
 * TODO hooks (deliberately stubbed — wired in later phases):
 *   hooks.getKnownIdentity — Shopify logged-in customer / Klaviyo profile
 *                            (known-user skip removes the email step)
 *   recentHandles          — recently-viewed product handles for Discovery
 *                            resize cards (v1 sends [] — plumbed, deferred)
 *
 * Analytics (hooks.track): ONE GTM dataLayer push per event feeds both GA4
 * and Klaviyo — the widget never talks to either directly. The default sink
 * is dataLayerPush below, wired here rather than in the Liquid embed so both
 * placements get it; override with mount(el, { track: fn }). Events:
 *   size_tool_start    — start() AND restart() (a new lookup is a new start,
 *                        or completes outnumber starts in any event count)
 *   size_tool_complete — size_tool_row_type "recommendation" (a confirmed
 *                        lookup) or "escalation" (the §18 escape hatch),
 *                        mirroring audit_log_reporting.row_type so GA4 and
 *                        the audit log reconcile row for row
 * The tool owns this event namespace deliberately: form_submit is already a
 * GA4 key event fired by other site forms AND an automatic enhanced-
 * measurement event, so reusing it would blend three unrelated populations.
 * Params are size_tool_-prefixed for the same reason (and so GTM maps each
 * to its GA4 custom dimension by identity). form_name: "size_tool" stays
 * bare on both events as a stable filter key for shared triggers/reporting.
 * Cart adds are deliberately NOT pushed: Shopify's native tracking already
 * counts them and a second push would double-count. Nothing identifying is
 * ever pushed — no email, no first name, no escalation free text.
 */

(function (root, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = factory(require("./copy.js"));
  } else {
    root.LHLSizeTool = factory(root.LHL_COPY);
  }
})(typeof self !== "undefined" ? self : this, function (copyModule) {
  "use strict";

  // The UMD wrapper's `root` is not visible inside this factory — capture
  // the global object explicitly for anything that needs it (fetch binding).
  var GLOBAL = typeof globalThis !== "undefined" ? globalThis
    : typeof self !== "undefined" ? self
    : typeof window !== "undefined" ? window
    : this;

  var COPY = copyModule.COPY;
  var formatCopy = copyModule.formatCopy;

  var DEFAULTS = {
    apiBaseUrl: "http://127.0.0.1:8000",
    shopBaseUrl: "https://littlehumanlinens.com",
    contactUrl: "#talk-to-us", // TODO: real contact page URL when embedded
    placement: "discovery",
    requestTimeoutMs: 8000,
    debounceMs: 200,
  };

  // Stamped on every push so the existing site-wide GTM form trigger can tell
  // tool events from every other form on the storefront.
  var FORM_NAME = "size_tool";

  // The only two placements. data-placement is theme-authored, so an unknown
  // value is caught at mount rather than propagated (see mount()).
  var PLACEMENTS = ["pdp", "discovery"];

  // Outcome as the AUDIT LOG spells it. GA4 has to reconcile with
  // audit_log_reporting without a translation layer downstream, so the push
  // carries these strings — not the widget's internal MATCH / DOESNT_FIT /
  // PENDING / NOT_FOUND, which stay exactly as they are everywhere else.
  // This is a mapping at the push site ONLY.
  //
  // Must stay byte-identical to app/main.py's AUDIT_OUTCOME and the
  // audit_log outcome CHECK constraint (migrations/001_init.sql) — note the
  // ASCII apostrophe in "Doesn't Fit" and the hyphens in the other two.
  var AUDIT_OUTCOME = {
    MATCH: "Match",
    DOESNT_FIT: "Doesn't Fit",
    PENDING: "Known-Pending",
    NOT_FOUND: "Not-Found",
  };


  // -------------------------------------------------------------------------
  // API client — thin, timeout-guarded; every failure becomes a typed error
  // so the flow can always show the calm "having trouble" state (never hangs).
  // -------------------------------------------------------------------------

  function createApiClient(config, fetchImpl) {
    var doFetch = fetchImpl || (typeof fetch !== "undefined" ? fetch.bind(GLOBAL) : null);

    function request(path, options) {
      var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () { controller.abort(); }, config.requestTimeoutMs)
        : null;
      var opts = Object.assign({}, options, controller ? { signal: controller.signal } : {});
      return doFetch(config.apiBaseUrl + path, opts)
        .then(function (res) {
          if (!res.ok) {
            var err = new Error("api error");
            err.status = res.status;
            throw err;
          }
          return res.json();
        })
        .finally(function () { if (timer) clearTimeout(timer); });
    }

    return {
      search: function (q) {
        return request("/v1/search?q=" + encodeURIComponent(q));
      },
      models: function (brand, q) {
        return request(
          "/v1/models?brand=" + encodeURIComponent(brand) + "&q=" + encodeURIComponent(q)
        );
      },
      confirm: function (payload) {
        return request("/v1/confirm", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      },
      escalate: function (payload) {
        return request("/v1/escalate", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      },
    };
  }

  // -------------------------------------------------------------------------
  // Cart client — Shopify's NATIVE AJAX cart, exactly as the storefront's own
  // add-to-cart uses it: POST /cart/add.js with numeric variant ids. Same
  // origin as the storefront page (cartBaseUrl stays "" when embedded).
  // -------------------------------------------------------------------------

  function createCartClient(config, fetchImpl) {
    var doFetch = fetchImpl || (typeof fetch !== "undefined" ? fetch.bind(GLOBAL) : null);
    return {
      add: function (variantId) {
        var payload = { items: [{ id: variantId, quantity: 1 }] };
        // Dawn: ask /cart/add.js to render the cart sections in the SAME
        // response (Section Rendering API) — exactly what Dawn's own product
        // form does — so the drawer + count bubble can update without a
        // reload. Feature-detected; theme introspection must never block
        // the add itself.
        try {
          var themeCart = findThemeCartElement();
          if (themeCart && typeof themeCart.getSectionsToRender === "function") {
            payload.sections = themeCart.getSectionsToRender()
              .map(function (section) { return section.id; });
            payload.sections_url = (GLOBAL.location && GLOBAL.location.pathname) || "/";
          }
        } catch (e) { /* no sections: the add still goes through */ }
        return doFetch((config.cartBaseUrl || "") + "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }).then(function (res) {
          if (!res.ok) {
            var err = new Error("cart error");
            err.status = res.status;
            throw err;
          }
          return res.json();
        }).then(function (body) {
          notifyThemeCartUpdated(body, config, doFetch);
          return body;
        });
      },
    };
  }

  // Dawn's cart UI component, when present (cart-notification is checked
  // first, matching Dawn's own product-form order). Null on other themes.
  function findThemeCartElement() {
    if (typeof document === "undefined" || typeof document.querySelector !== "function") {
      return null;
    }
    try {
      return document.querySelector("cart-notification")
        || document.querySelector("cart-drawer");
    } catch (e) {
      return null;
    }
  }

  // Every section Dawn's component will try to swap MUST have non-empty
  // HTML in the response — a missing/empty entry would leave the drawer's
  // inner container unpopulated and Dawn's focus-trap would crash on null.
  function sectionsComplete(themeCart, cartData) {
    if (!cartData || !cartData.sections) return false;
    var sections = themeCart.getSectionsToRender();
    if (!sections || !sections.length) return false;
    for (var i = 0; i < sections.length; i++) {
      var html = cartData.sections[sections[i].id];
      if (typeof html !== "string" || html.length === 0) return false;
    }
    return true;
  }

  // SAFE minimal fallback: refresh only the cart-count bubble TEXT from
  // /cart.js. Never touches the drawer, never opens anything, never throws —
  // this path can not crash a theme.
  function safeCartBubbleUpdate(config, doFetch) {
    try {
      if (!doFetch || typeof document === "undefined"
          || typeof document.querySelector !== "function") {
        return;
      }
      doFetch((config.cartBaseUrl || "") + "/cart.js", {
        headers: { "Content-Type": "application/json" },
      }).then(function (res) {
        return res && res.ok ? res.json() : null;
      }).then(function (cart) {
        if (!cart || typeof cart.item_count !== "number") return;
        var bubble = document.querySelector(
          "#cart-icon-bubble .cart-count-bubble span[aria-hidden='true'], "
          + ".cart-count-bubble span[aria-hidden='true']");
        if (bubble) bubble.textContent = String(cart.item_count);
      }).catch(function () { /* silent */ });
    } catch (e) { /* silent */ }
  }

  // ── THEME-TUNING SEAM ──────────────────────────────────────────────────
  // The single place cart-UI refresh lives. Layered, ALL feature-detected
  // and fail-silent — the add already succeeded server-side:
  //   1. Dawn component refresh: hand the section-rendered /cart/add.js
  //      response to <cart-notification>/<cart-drawer>.renderContents() so
  //      Dawn does its OWN swap + open (we never open the drawer or swap
  //      HTML ourselves — the focus-trap must run against DOM Dawn itself
  //      populated). Called ONLY when the response carries non-empty HTML
  //      for every id the component's own getSectionsToRender() returned
  //      (ids are read at runtime, never hardcoded).
  //      Empty cart -> first item: Dawn's open() focus-traps
  //      `.drawer__inner-empty` while the element still carries `is-empty`,
  //      but the swapped-in HTML is the non-empty drawer — that trap target
  //      is gone and trapFocus(null) crashes (the exact TypeError seen at
  //      cart-drawer.js getFocusableElements). The cart is guaranteed
  //      non-empty after our successful add, so the stale flag is cleared
  //      BEFORE Dawn opens.
  //   2. If the component/hooks are absent, the payload is incomplete, or
  //      renderContents throws: the SAFE fallback above (bubble text only,
  //      drawer untouched, never opened).
  //   3. Dawn pub/sub + generic events, as before.
  // MANUAL VERIFICATION REQUIRED on the real Dawn theme (cannot be unit-
  // tested) — with the DRAWER cart type:
  //   a. add from an EMPTY cart: drawer opens populated, count bubble
  //      appears, NO console TypeError from cart-drawer.js trapFocus;
  //   b. add with items already in the cart: drawer refreshes + opens;
  //   c. cart-NOTIFICATION cart type: popup shows the added item;
  //   d. temporarily rename <cart-drawer> in devtools to force the
  //      fallback: count bubble still updates, drawer stays shut, no errors;
  //   e. repeat (a) and (b) on mobile layout.
  function notifyThemeCartUpdated(cartData, config, doFetch) {
    var rendered = false;
    try {
      var themeCart = findThemeCartElement();
      if (themeCart
          && typeof themeCart.renderContents === "function"
          && typeof themeCart.getSectionsToRender === "function"
          && sectionsComplete(themeCart, cartData)) {
        try {
          if (themeCart.classList && themeCart.classList.contains("is-empty")) {
            themeCart.classList.remove("is-empty");
          }
        } catch (e) { /* class fixup is best-effort */ }
        themeCart.renderContents(cartData); // Dawn swaps + opens itself
        rendered = true;
      }
    } catch (e) {
      rendered = false; // drawer refused the payload; never re-trigger open
    }
    if (!rendered) {
      safeCartBubbleUpdate(config, doFetch);
    }
    try {
      if (typeof GLOBAL.publish === "function" && GLOBAL.PUB_SUB_EVENTS
          && GLOBAL.PUB_SUB_EVENTS.cartUpdate) {
        GLOBAL.publish(GLOBAL.PUB_SUB_EVENTS.cartUpdate,
          { source: "lhl-size-tool", cartData: cartData });
      }
    } catch (e) { /* no pub/sub listeners: silently fine */ }
    try {
      if (typeof document !== "undefined" && typeof CustomEvent !== "undefined") {
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        document.dispatchEvent(new CustomEvent("lhl:cart:added", { bubbles: true }));
      }
    } catch (e) { /* no listeners / restricted env: silently fine */ }
  }

  // -------------------------------------------------------------------------
  // Analytics sink — GTM dataLayer.
  // -------------------------------------------------------------------------

  // A misconfigured embed is a real fault that silently skews reporting and
  // 422s the API, so it goes to console.error, not warn: it must stay visible
  // in a console filtered to errors.
  function embedError(message) {
    try {
      if (typeof console !== "undefined" && console
          && typeof console.error === "function") {
        console.error(message);
      }
    } catch (e) { /* never break a mount over a log line */ }
  }

  // dataLayer is read at PUSH time, never captured: GTM may initialise after
  // the widget mounts. Its absence (GTM blocked, consent-gated, not yet
  // loaded) is a normal state, not an error — tracking must never break the
  // tool, so every failure here is swallowed.
  function dataLayerPush(event, params) {
    try {
      var dl = GLOBAL && GLOBAL.dataLayer;
      if (!dl || typeof dl.push !== "function") return;
      dl.push(Object.assign({ event: event }, params || {}));
    } catch (e) { /* a hostile or exotic dataLayer is not our problem */ }
  }

  // -------------------------------------------------------------------------
  // Flow — DOM-free state machine. Screens:
  //   welcome -> search -> (models) -> email -> loading -> result | error
  // Every branch has a path forward or to a human; retry never dead-ends.
  // -------------------------------------------------------------------------

  function createFlow(deps) {
    var api = deps.api;
    var hooks = deps.hooks || {};
    var placement = deps.placement || "discovery";
    var cart = deps.cart || null;
    // Display-routing context ONLY — never a size-decision input. PDP: the
    // mounted product's handle. Discovery: recently-viewed handles (v1 sends
    // the empty array; the plumbing is here so populating it later is a
    // one-line change).
    var productHandle = deps.productHandle || null;
    var recentHandles = deps.recentHandles || [];

    var state = {
      screen: "welcome",
      query: "",
      searchResults: [],
      searched: false,
      brandContext: null,      // set after tapping a collapsed brand entry
      modelQuery: "",
      modelSuggestions: [],
      crossBrandSuggestions: [],  // "did you mean" rescue hits (in-brand miss only)
      modelSearched: false,
      selection: null,         // {confirmBrand, brand, model, label}
      identity: null,          // {firstName, email} or known-user identity
      knownIdentity: null,     // set at selection when the user is attributable
      // Session-scoped email reuse: once given, later lookups in the SAME
      // session skip the email FIELD (never the safety ack). Lives in
      // in-memory state ONLY, never in any browser storage, so a fresh
      // page load re-asks. "Start again" keeps it (same session).
      sessionIdentity: null,
      emailChangeRequested: false,
      // In-progress form values. Screens re-render on state changes (e.g.
      // ticking the safety ack), so typed values must survive the rebuild:
      // inputs write here as the user types, renders read from here.
      formFirstName: "",
      formEmail: "",
      escFirstName: "",
      escEmail: "",
      escDescription: "",
      emailError: false,
      result: null,            // /v1/confirm response
      ackChecked: false,
      ackNudge: false,
      cartBusyId: null,        // numeric variant id of an in-flight add
      cartAddedId: null,       // numeric variant id last added (confirmation)
      retryAction: null,       // re-run after "Try again"
      // The ONE escalation link (copy: COPY.escalation.link). Never shown at
      // the start; appears after an empty/weak search and stays for the session.
      showEscalationLink: false,
      escalationError: null,   // null | "email" | "description"
      // Loading copy routing: form-submit escalations show their own
      // loading line (micro.loadingEscalation); everything else on the
      // loading screen is a size lookup and keeps micro.loadingLookup —
      // including the pending path's auto-escalation, which the customer
      // experiences as part of their lookup.
      escalationLoading: false,
    };

    var listeners = [];
    function notify() {
      listeners.forEach(function (fn) { fn(state); });
    }
    function set(patch) {
      Object.assign(state, patch);
      notify();
    }
    var seq = 0; // discard stale type-ahead responses

    // The ONE analytics funnel: every event in the widget goes through here.
    // form_name is stamped here rather than in the sink so a custom sink gets
    // it too — one push feeds GA4 and Klaviyo alike.
    //
    // Every tool-specific param is size_tool_-prefixed so GTM maps it to its
    // GA4 custom dimension by identity (one string per field, not two) and
    // nothing collides with another site form's params. The EVENT names are
    // namespaced for the same reason — form_submit is both a GA4 key event
    // from other site forms and an automatic enhanced-measurement event, so
    // the tool must not push it. form_name is the sole bare key: a stable
    // filter for any shared trigger or report that spans forms.
    function track(event, params) {
      if (!hooks.track) return;
      hooks.track(event, Object.assign({ form_name: FORM_NAME }, params || {}));
    }

    // Both size_tool_complete pushes share this shape, so every key is present on
    // every submit — a GA4 custom dimension that is sometimes absent is worse
    // than one that is explicitly null.
    function submitPush(fields) {
      // Fall back to the raw value rather than push undefined if an outcome
      // ever arrives that this map does not know: an unmapped string is
      // debuggable in GA4, a missing dimension is not.
      var auditOutcome = AUDIT_OUTCOME[fields.outcome] || fields.outcome;
      return {
        size_tool_row_type: fields.row_type,
        size_tool_outcome: auditOutcome,
        size_tool_recommended_size: fields.recommended_size || null,
        size_tool_furniture_type: fields.furniture_type || null,
        size_tool_brand: fields.brand || null,
        size_tool_model: fields.model || null,
        size_tool_placement: placement,
        // GA4 user properties persist BEYOND the session — that persistence
        // is what makes the used-the-tool cohort comparison possible.
        user_properties: {
          has_used_size_tool: true,
          // Same vocabulary as size_tool_outcome above: one concept must not
          // carry two spellings within a single push.
          size_tool_last_outcome: auditOutcome,
        },
      };
    }

    function fail(retryAction) {
      set({ screen: "error", retryAction: retryAction });
    }

    var flow = {
      state: state,
      onChange: function (fn) { listeners.push(fn); },

      start: function () {
        track("size_tool_start", { size_tool_placement: placement });
        set({ screen: "search", query: "", searchResults: [], searched: false });
      },

      searchInput: function (q) {
        state.query = q;
        var mySeq = ++seq;
        if (q.trim().length < 2) {
          set({ searchResults: [], searched: false });
          return Promise.resolve();
        }
        return api.search(q).then(function (body) {
          if (mySeq !== seq) return; // stale
          set({
            searchResults: body.results,
            searched: true,
            // Zero results above the API's match threshold = weak search:
            // reveal the escalation link, and keep it for the session.
            showEscalationLink: state.showEscalationLink || body.results.length === 0,
          });
        }).catch(function () {
          if (mySeq !== seq) return;
          fail(function () { return flow.searchInput(state.query); });
        });
      },

      tapSearchResult: function (item) {
        if (item.kind === "brand") {
          // Hand off to the two-stage flow within the tapped brand.
          set({
            screen: "models", brandContext: item,
            modelQuery: "", modelSuggestions: [],
            crossBrandSuggestions: [], modelSearched: false,
          });
        } else {
          flow._select(item.confirm_brand, item.brand, item.model, item.label);
        }
      },

      modelInput: function (q) {
        state.modelQuery = q;
        var mySeq = ++seq;
        if (q.trim().length < 2) {
          set({ modelSuggestions: [], crossBrandSuggestions: [], modelSearched: false });
          return Promise.resolve();
        }
        return api.models(state.brandContext.confirm_brand, q).then(function (body) {
          if (mySeq !== seq) return;
          var cross = body.cross_brand || [];
          set({
            modelSuggestions: body.suggestions,
            crossBrandSuggestions: cross,
            modelSearched: true,
            // Escalation only when nothing matches ANYWHERE — a cross-brand
            // rescue is still a path forward.
            showEscalationLink: state.showEscalationLink
              || (body.suggestions.length === 0 && cross.length === 0),
          });
        }).catch(function () {
          if (mySeq !== seq) return;
          fail(function () { return flow.modelInput(state.modelQuery); });
        });
      },

      tapModelSuggestion: function (s) {
        var confirmBrand = state.brandContext ? state.brandContext.confirm_brand : s.brand;
        flow._select(confirmBrand, s.brand, s.model, s.model + " by " + s.brand);
      },

      // Cross-brand "did you mean" tap: switches the selection to THAT
      // entry's brand+model and continues normally. The size answer still
      // comes from the verified lookup on the confirmed row.
      tapCrossBrandSuggestion: function (s) {
        flow._select(s.brand, s.brand, s.model, s.model + " by " + s.brand);
      },

      // The escalation form (opened via the conditional escalation link).
      openEscalation: function () {
        set({ screen: "escalate", escalationError: null,
              escFirstName: "", escEmail: "", escDescription: "" });
      },

      // The §18 free-text Not-Found escalation: ONE description box, no
      // structured brand/model. The API raises the Gorgias ticket (customer
      // as requester, tags size-tool + size-tool-not-found) and audits;
      // success shows §11, a failure shows §14 with retry.
      submitEscalation: function (firstName, email, description) {
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());
        var descOk = (description || "").trim().length > 0;
        // Two required fields ON THE FORM (the API itself accepts an empty
        // description — the pending path has none), distinguished so the
        // inline error names the actual problem: email checked first (both
        // wrong -> email message, the description message follows next).
        if (!emailOk) {
          set({ escalationError: "email" });
          return Promise.resolve(false);
        }
        if (!descOk) {
          set({ escalationError: "description" });
          return Promise.resolve(false);
        }
        set({ screen: "loading", escalationLoading: true });
        return api.escalate({
          first_name: (firstName || "").trim(),
          email: email.trim(),
          description: description.trim(),
          outcome: "NOT_FOUND",
          placement: placement,
        }).then(function () {
          // The escape hatch is a submit too. Without this it is invisible in
          // GA4 while still being a row in the audit log, and the two never
          // reconcile. Brand/model are the context the customer had on screen
          // (brandContext survives openEscalation; only restart() clears it)
          // and this push is the ONLY place that context is recorded at all —
          // the /v1/escalate payload carries no structured brand/model. The
          // free-text description is NEVER pushed.
          track("size_tool_complete", submitPush({
            row_type: "escalation",
            outcome: "NOT_FOUND",
            brand: state.brandContext && state.brandContext.brand,
            model: (state.modelQuery || "").trim(),
          }));
          set({ screen: "escalated" });
          return true;
        }).catch(function () {
          fail(function () {
            return flow.submitEscalation(firstName, email, description);
          });
        });
      },

      _select: function (confirmBrand, brand, model, label) {
        state.selection = {
          confirmBrand: confirmBrand, brand: brand, model: model, label: label,
        };
        // Known-user skip removes the EMAIL FIELD only, never the safety
        // acknowledgement: known users see the same step without the email
        // inputs, and the tick is still required before any result.
        // TODO: wire real identity source (Shopify customer / Klaviyo).
        state.knownIdentity = hooks.getKnownIdentity ? hooks.getKnownIdentity() : null;
        set({ screen: "email", emailError: false,
              // First entry: UNticked (active acknowledgement required).
              // Same-session reuse: the customer already actively ticked it
              // this session, so it renders PRE-TICKED. Still un-skippable,
              // still recorded truthfully as safety_ack on every confirm.
              ackChecked: !state.knownIdentity && !!state.sessionIdentity,
              ackNudge: false, formFirstName: "", formEmail: "",
              emailChangeRequested: false });
      },

      // "Not you? Change" on a reused-email lookup: back to full email entry,
      // prefilled with the session email so it's easy to correct.
      changeEmail: function () {
        set({
          emailChangeRequested: true,
          // A different person may be taking over: back to an active tick.
          ackChecked: false,
          formFirstName: (state.sessionIdentity && state.sessionIdentity.firstName) || "",
          formEmail: (state.sessionIdentity && state.sessionIdentity.identifier) || "",
          emailError: false,
        });
      },

      // Persist an in-progress field value WITHOUT re-rendering (typing must
      // never rebuild the form under the user's cursor).
      updateField: function (field, value) {
        if (Object.prototype.hasOwnProperty.call(state, field)) {
          state[field] = value;
        }
      },

      submitEmail: function (firstName, email) {
        // The safety acknowledgement gates progression to the result, for
        // EVERY outcome and every identity. Un-skippable.
        if (!state.ackChecked) {
          set({ ackNudge: true });
          return Promise.resolve(false);
        }
        if (state.knownIdentity) {
          state.identity = state.knownIdentity;
          return flow._confirm();
        }
        // Session email reuse: field skipped, ack already required above.
        if (state.sessionIdentity && !state.emailChangeRequested) {
          state.identity = state.sessionIdentity;
          return flow._confirm();
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim())) {
          set({ emailError: true });
          return Promise.resolve(false);
        }
        state.identity = {
          firstName: (firstName || "").trim(),
          identifier: email.trim(),
          identifier_type: "email",
        };
        // Remember for the rest of the session (in-memory only).
        state.sessionIdentity = state.identity;
        return flow._confirm();
      },

      _confirm: function () {
        set({ screen: "loading", escalationLoading: false });
        var payload = {
          brand: state.selection.confirmBrand,
          model: state.selection.model,
          // Ticked on the step before the result and required to get here,
          // so every audited lookup records the acknowledgement.
          safety_ack: state.ackChecked,
          identifier: state.identity.identifier,
          identifier_type: state.identity.identifier_type,
          placement: placement,
          // Enrichment display context (never a decision input): the PDP's
          // mounted product, and recently-viewed handles for Discovery.
          product_handle: placement === "pdp" ? productHandle : null,
          recent_handles: placement === "discovery" ? recentHandles : [],
        };
        return api.confirm(payload).then(function (body) {
          track("size_tool_complete", submitPush({
            row_type: "recommendation",
            outcome: body.outcome,
            // The CANONICAL Type, not the §19 display form: this has to
            // reconcile with audit_log.recommended_size, which is canonical.
            recommended_size: body.size_type,
            furniture_type: body.furniture_type,
            brand: body.brand,
            model: body.model,
          }));
          if (body.escalate) {
            // PENDING / NOT_FOUND: raise the support ticket BEFORE the
            // §10/§11 screen — that copy promises a reply within 1 business
            // day, so it must never render unless the escalation is safely
            // with the team (a Gorgias outage degrades server-side and
            // still returns success; only a real API failure shows §14).
            return flow._escalate(body);
          }
          // ackChecked persists: it was required to get here and is part of
          // the audited state for this recommendation.
          set({ screen: "result", result: body, ackNudge: false });
        }).catch(function () {
          fail(function () { return flow._confirm(); });
        });
      },

      // Escalation for confirmed PENDING / NOT_FOUND outcomes. These have
      // no free-text box, so the confirmed brand+model string rides in
      // description — the only thing the team needs to chase the size. Uses
      // the identity the flow already holds. TODO(known-user skip): a
      // non-email identity can't be a Gorgias requester; when known-user
      // identities arrive, add the conditional confirm-your-email ask here
      // (Copy Set §5) instead of skipping the ticket.
      _escalate: function (result) {
        if (state.identity.identifier_type !== "email") {
          set({ screen: "result", result: result, ackNudge: false });
          return Promise.resolve(true);
        }
        // Still the customer's lookup from their point of view — the
        // loading copy stays "Finding your fit…", not the form-submit line.
        set({ screen: "loading", escalationLoading: false });
        return api.escalate({
          first_name: state.identity.firstName || "",
          email: state.identity.identifier,
          description: result.brand + " " + result.model,
          outcome: result.outcome,
          placement: placement,
        }).then(function () {
          set({ screen: "result", result: result, ackNudge: false });
          return true;
        }).catch(function () {
          fail(function () { return flow._escalate(result); });
        });
      },

      toggleAck: function (checked) {
        set({ ackChecked: checked, ackNudge: false });
      },

      // Add ONE item to the native Shopify cart, on explicit tap only (never
      // auto-adds). No acknowledgement gate here: the §13 safety tick lives
      // on the email/ack step for ALL placements and was required to reach
      // any result, logged as safety_ack on the confirm.
      addToCart: function (variantId) {
        if (!variantId || state.cartBusyId) return Promise.resolve(false);
        set({ cartBusyId: variantId, cartAddedId: null });
        var add = cart && cart.add
          ? cart.add(variantId)
          : Promise.resolve(true); // no cart wired (tests/dev): succeed quietly
        return Promise.resolve(add).then(function () {
          // Deliberately NOT tracked: Shopify's native cart tracking already
          // counts this add, and a widget push would double-count it.
          set({ cartBusyId: null, cartAddedId: variantId });
          return true;
        }).catch(function () {
          // Calm failure: re-enable the button; the collection link on every
          // MATCH screen keeps a path forward. Never a hang or a dead end.
          set({ cartBusyId: null });
          return false;
        });
      },

      retry: function () {
        var action = state.retryAction;
        if (!action) return flow.restart();
        // Return to a sensible screen for input retries; confirm retries rerun.
        set({ screen: state.selection && state.identity ? "loading" : "search" });
        return action();
      },

      restart: function () {
        // A new lookup is a new start. restart() re-enters at `search` and
        // never routes through start(), so without this size_tool_complete can
        // outnumber size_tool_start in any event-count report.
        track("size_tool_start", { size_tool_placement: placement });
        set({
          screen: "search", query: "", searchResults: [], searched: false,
          brandContext: null, modelQuery: "", modelSuggestions: [],
          crossBrandSuggestions: [],
          modelSearched: false, selection: null, identity: null,
          knownIdentity: null,
          formFirstName: "", formEmail: "",
          escFirstName: "", escEmail: "", escDescription: "",
          emailError: false, result: null, ackChecked: false,
          ackNudge: false, cartBusyId: null, cartAddedId: null,
          retryAction: null, escalationError: null,
          escalationLoading: false,
          emailChangeRequested: false,
          // Deliberately NOT reset (session-scoped, in-memory only):
          // showEscalationLink stays once revealed, and sessionIdentity keeps
          // the email through "Start again" — only a fresh page load re-asks.
        });
      },
    };

    return flow;
  }

  // -------------------------------------------------------------------------
  // DOM layer — renders flow state. No customer-facing literals here; every
  // string is COPY.* (single source: docs/LHL_Size_Tool_Copy_Set.md).
  // -------------------------------------------------------------------------

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function mount(container, options) {
    function attrOf(name) {
      return typeof container.getAttribute === "function"
        ? container.getAttribute(name) : null;
    }
    // Theme-embed contract: config rides on the mount element as data-
    // attributes (set by the Liquid snippet/section — see theme/EMBED.md):
    //   data-api-base        — API base URL (no production URL is ever
    //                          hardcoded in this file; DEFAULTS is local dev)
    //   data-placement       — "pdp" | "discovery"
    //   data-product-handle  — PDP product (display-routing only)
    //   data-shop-base       — link base; "" = relative (on-storefront)
    // Explicit mount(el, options) values always win over attributes.
    var fromAttrs = {};
    if (attrOf("data-api-base")) fromAttrs.apiBaseUrl = attrOf("data-api-base");
    if (attrOf("data-placement")) fromAttrs.placement = attrOf("data-placement");
    if (attrOf("data-shop-base") !== null) fromAttrs.shopBaseUrl = attrOf("data-shop-base");
    // Landing-hero overrides (theme-editor section settings). ONLY the hero
    // heading/sub are overridable this way — every functional, step, result
    // and safety string stays single-sourced in copy.js / the Copy Set.
    if (attrOf("data-hero-heading")) fromAttrs.heroHeading = attrOf("data-hero-heading");
    if (attrOf("data-hero-sub")) fromAttrs.heroSub = attrOf("data-hero-sub");
    var config = Object.assign({}, DEFAULTS, fromAttrs, options || {});
    // data-placement is theme-authored, so a typo is a real possibility, and
    // it is load-bearing three times over: it picks the layout mode, rides
    // into every analytics push as a custom dimension, and is pattern-checked
    // by /v1/confirm + /v1/escalate (an unknown value 422s -> the error
    // screen). Fall back rather than propagate a bad value into all three,
    // and say so loudly — a broken embed must not fail quietly.
    if (PLACEMENTS.indexOf(config.placement) === -1) {
      embedError("LHL Size Tool: unknown data-placement "
        + JSON.stringify(config.placement)
        + ' - falling back to "discovery" (expected "pdp" or "discovery").');
      config.placement = "discovery";
    }
    var api = createApiClient(config, config.fetchImpl);
    // PDP embeds: the theme snippet sets data-product-handle on the mount
    // element (display-routing only; options.productHandle can override).
    var productHandle = config.productHandle
      || attrOf("data-product-handle")
      || null;
    var flow = createFlow({
      api: api,
      placement: config.placement,
      productHandle: productHandle,
      recentHandles: config.recentHandles || [], // v1: empty — plumbed for later
      cart: config.cart || createCartClient(config, config.fetchImpl),
      hooks: {
        getKnownIdentity: config.getKnownIdentity || function () {
          // TODO(known-user skip): Shopify customer object / Klaviyo _learnq
          return null;
        },
        // The default sink lives HERE, not in the Liquid embed, so both
        // placements get it; mount(el, { track: fn }) still overrides.
        track: config.track || dataLayerPush,
        // (escalations are no longer a hook: both paths POST /v1/escalate)
      },
    });

    var debounceTimer = null;
    function debounced(fn) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fn, config.debounceMs);
    }

    function collectionUrl(handle) {
      return config.shopBaseUrl + "/collections/" + handle;
    }

    function link(text, href) {
      var a = el("a", "lhl-link", text);
      a.href = href;
      return a;
    }

    function backLink() {
      // Low-consequence action: neutral/subtle styling.
      var a = el("a", "lhl-back", COPY.micro.backLink);
      a.href = "#";
      a.addEventListener("click", function (e) { e.preventDefault(); flow.restart(); });
      return a;
    }

    // The ONE escalation link (§18): opens the escalation form. Rendered in
    // the footer once the session reveal has happened, and ALWAYS under the
    // model step's suggestion list (#4) — never both at once.
    function askUsLink() {
      var a = el("a", "lhl-link lhl-ask-us", COPY.escalation.link);
      a.href = "#";
      a.addEventListener("click", function (e) {
        e.preventDefault();
        flow.openEscalation();
      });
      return a;
    }

    // Footer row: the ONE escalation link on the left (only once the flow has
    // revealed it), "Start again" on the right. One row, never stacked.
    function footer(rootEl, opts) {
      var row = el("div", "lhl-footer-row");
      var any = false;
      if (opts.askUs && flow.state.showEscalationLink) {
        row.appendChild(askUsLink());
        any = true;
      }
      if (opts.back) {
        row.appendChild(backLink());
        any = true;
      }
      if (any) rootEl.appendChild(row);
    }

    // Form input bound to a flow-state field: the value survives re-renders
    // (e.g. ticking the safety ack), so completion ORDER never matters —
    // submit always validates whatever is in the fields at click time.
    function formField(type, placeholder, ariaLabel, stateField) {
      var input = el("input", "lhl-input");
      input.type = type;
      input.placeholder = placeholder;
      input.setAttribute("aria-label", ariaLabel);
      input.value = flow.state[stateField];
      input.addEventListener("input", function (event) {
        flow.updateField(stateField, input.value);
        // Form fields are SELF-CONTAINED: their input events must never
        // reach a delegated listener above them (live bug: a container-
        // level type-ahead handler treated escalation-description input as
        // a search-box change and re-rendered, clobbering the typed text).
        // Nothing outside the field has any business seeing these events.
        if (event && event.stopPropagation) event.stopPropagation();
      });
      return input;
    }

    function typeahead(placeholder, value, onInput) {
      var wrap = el("div", "lhl-typeahead");
      var input = el("input", "lhl-input");
      input.type = "text";
      input.placeholder = placeholder;
      input.value = value;
      // Brand/model names are proper nouns the browser doesn't know: with
      // assistance on, fast typing gets autocorrected/stripped mid-word
      // while the suggestion list re-renders. All four attributes off —
      // the type-ahead is the only "assistance" this field should have.
      input.setAttribute("autocomplete", "off");
      input.setAttribute("autocorrect", "off");
      input.setAttribute("autocapitalize", "off");
      input.setAttribute("spellcheck", "false");
      // Type-ahead is bound DIRECTLY to this search input — never delegated
      // from a container (a delegated variant once re-rendered on every
      // field's input, wiping the escalation description). The target check
      // makes the scoping explicit even if this handler is ever re-bound
      // on an ancestor; search keystrokes also stay our own (stopPropagation)
      // so no outer listener can double-process them.
      input.addEventListener("input", function (event) {
        if (event && event.target && event.target !== input) return;
        if (event && event.stopPropagation) event.stopPropagation();
        var q = input.value;
        debounced(function () { onInput(q); });
      });
      wrap.appendChild(input);
      setTimeout(function () { input.focus(); }, 0);
      return wrap;
    }

    function suggestionList(items, labelFor, onTap, searched) {
      var list = el("ul", "lhl-suggestions");
      if (!items.length) {
        // Content-driven height: the typeahead empty-state line renders only
        // when a search actually ran — never an empty spacer row.
        if (searched) list.appendChild(el("li", "lhl-empty", COPY.micro.typeaheadEmpty));
        return list;
      }
      items.forEach(function (item) {
        var li = el("li", "lhl-suggestion");
        var btn = el("button", "lhl-suggestion-btn", labelFor(item));
        btn.type = "button";
        btn.addEventListener("click", function () { onTap(item); });
        li.appendChild(btn);
        list.appendChild(li);
      });
      return list;
    }

    function renameNote(result, parent) {
      if (result.acknowledgement && COPY.brandRename[result.acknowledgement]) {
        parent.appendChild(
          el("p", "lhl-rename-note", COPY.brandRename[result.acknowledgement])
        );
      }
    }

    function safetyAckBlock(parent) {
      var wrap = el("div", "lhl-ack");
      var lbl = el("label", "lhl-ack-label");
      var box = document.createElement("input");
      box.type = "checkbox";
      box.className = "lhl-ack-box";
      box.checked = flow.state.ackChecked;
      box.addEventListener("change", function () { flow.toggleAck(box.checked); });
      lbl.appendChild(box);
      lbl.appendChild(el("span", null, COPY.safetyAck.label));
      wrap.appendChild(lbl);
      if (flow.state.ackNudge) {
        wrap.appendChild(el("p", "lhl-ack-nudge", COPY.safetyAck.nudge));
      }
      parent.appendChild(wrap);
    }

    function screenWelcome(rootEl) {
      // Heading/sub can be overridden per-placement via data-hero-heading /
      // data-hero-sub; blank falls back to the canonical Copy Set strings.
      rootEl.appendChild(el("h2", "lhl-heading",
        config.heroHeading || COPY.welcome.heading));
      rootEl.appendChild(el("p", "lhl-sub", config.heroSub || COPY.welcome.sub));
      var btn = el("button", "lhl-btn lhl-btn-primary", COPY.welcome.button);
      btn.type = "button";
      btn.addEventListener("click", function () { flow.start(); });
      rootEl.appendChild(btn);
    }

    function screenSearch(rootEl) {
      var s = flow.state;
      rootEl.appendChild(el("h2", "lhl-heading", COPY.stepBrand.heading));
      rootEl.appendChild(typeahead(
        COPY.stepBrand.placeholder, s.query,
        function (q) { flow.searchInput(q); }
      ));
      rootEl.appendChild(suggestionList(
        s.searchResults,
        function (r) { return r.label; },
        function (r) { flow.tapSearchResult(r); },
        s.searched
      ));
      footer(rootEl, { askUs: true, back: false });
    }

    function screenModels(rootEl) {
      var s = flow.state;
      rootEl.appendChild(el("h2", "lhl-heading", COPY.stepModel.heading));
      rootEl.appendChild(el("p", "lhl-sub", s.brandContext.brand));
      rootEl.appendChild(typeahead(
        COPY.stepModel.placeholder, s.modelQuery,
        function (q) { flow.modelInput(q); }
      ));
      rootEl.appendChild(suggestionList(
        s.modelSuggestions,
        function (m) { return m.model + " by " + m.brand; },
        function (m) { flow.tapModelSuggestion(m); },
        s.modelSearched && s.crossBrandSuggestions.length === 0
      ));
      // Cross-brand "did you mean" rescue — only ever present when the
      // in-brand list is empty (the API guarantees it never overrides a
      // real in-brand match).
      if (s.crossBrandSuggestions.length) {
        rootEl.appendChild(el("p", "lhl-did-you-mean",
          formatCopy(COPY.stepModel.didYouMean, { Brand: s.brandContext.brand })));
        rootEl.appendChild(suggestionList(
          s.crossBrandSuggestions,
          function (m) { return m.label; },
          function (m) { flow.tapCrossBrandSuggestion(m); },
          true
        ));
      }
      // #4: whenever suggestions are on screen, the escape hatch rides at
      // the bottom of the list — the customer's model may simply not be
      // among them. Model step only; the zero-results session reveal below
      // is unchanged, and the footer link is skipped while this inline one
      // renders so the flow never shows two.
      var hasSuggestions = s.modelSuggestions.length > 0
        || s.crossBrandSuggestions.length > 0;
      if (hasSuggestions) {
        var askRow = el("p", "lhl-ask-us-row");
        askRow.appendChild(askUsLink());
        rootEl.appendChild(askRow);
      }
      footer(rootEl, { askUs: !hasSuggestions, back: true });
    }

    function screenEmail(rootEl) {
      var c = COPY.emailNew;
      var s = flow.state;
      var known = !!s.knownIdentity;
      // Session email reuse: field skipped, email disclosed with a change
      // option. In-memory only — a fresh page load re-asks.
      var reused = !known && !!s.sessionIdentity && !s.emailChangeRequested;
      var showFields = !known && !reused;
      // Reused-email lookups skip the step heading too — the disclosure
      // notice, safety ack and button carry the step on their own.
      if (!reused) {
        rootEl.appendChild(el("h2", "lhl-heading", c.heading));
      }
      var form = el("form", "lhl-email-form");
      var nameInput = null;
      var emailInput = null;
      if (reused) {
        // Disclose the attribution, per the privacy rules.
        var notice = el("p", "lhl-body lhl-reuse-notice",
          formatCopy(c.reuseNotice, { Email: s.sessionIdentity.identifier }) + " ");
        var change = el("a", "lhl-link lhl-reuse-change", c.reuseChangeLink);
        change.href = "#";
        change.addEventListener("click", function (e) {
          e.preventDefault();
          flow.changeEmail();
        });
        notice.appendChild(change);
        form.appendChild(notice);
      }
      if (showFields) {
        // Known/reused users skip the email FIELDS only; the tick stays.
        nameInput = formField("text", c.firstNamePlaceholder, c.firstNameLabel,
                              "formFirstName");
        emailInput = formField("email", c.emailPlaceholder, c.emailLabel,
                               "formEmail");
        form.appendChild(nameInput);
        form.appendChild(emailInput);
      }
      // Safety acknowledgement: required for every outcome and identity,
      // acknowledged BEFORE any result is shown.
      safetyAckBlock(form);
      var btn = el("button", "lhl-btn lhl-btn-primary", c.button);
      btn.type = "submit";
      form.appendChild(btn);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        flow.submitEmail(nameInput ? nameInput.value : "",
                         emailInput ? emailInput.value : "");
      });
      rootEl.appendChild(form);
      if (flow.state.emailError) {
        rootEl.appendChild(el("p", "lhl-field-error", c.emailError));
      }
      if (showFields) {
        // Privacy explainer sits BELOW the button, per the Copy Set — shown
        // only when the email fields are (collection point).
        rootEl.appendChild(el("p", "lhl-body lhl-privacy-note", c.bodyUnderButton));
      }
      footer(rootEl, { askUs: true, back: true });
    }

    function screenEscalate(rootEl) {
      var c = COPY.escalation;
      rootEl.appendChild(el("h2", "lhl-heading", c.heading));
      rootEl.appendChild(el("p", "lhl-body", c.body));
      var form = el("form", "lhl-escalation-form");
      var nameInput = formField("text", c.firstNamePlaceholder,
                                c.firstNameLabel, "escFirstName");
      var emailInput = formField("email", c.emailPlaceholder,
                                 c.emailLabel, "escEmail");
      // Single-line text input, deliberately NOT a textarea: the live theme
      // interfered with textareas specifically (focus landed, no text
      // entered) while plain inputs typed fine. Built exactly like the
      // email field, bound to escDescription.
      var descInput = formField("text", c.descriptionPlaceholder,
                                c.descriptionLabel, "escDescription");
      var btn = el("button", "lhl-btn lhl-btn-primary", c.button);
      btn.type = "submit";
      form.appendChild(nameInput);
      form.appendChild(emailInput);
      form.appendChild(descInput);
      form.appendChild(btn);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        flow.submitEscalation(nameInput.value, emailInput.value, descInput.value);
      });
      rootEl.appendChild(form);
      if (flow.state.escalationError) {
        rootEl.appendChild(el("p", "lhl-field-error",
          flow.state.escalationError === "description"
            ? c.descriptionError : c.emailError));
      }
      footer(rootEl, { askUs: false, back: true });
    }

    // Free-text form success: §11 (Not-Found) confirms the escalation. Its
    // statement names what the customer was after — the best context on
    // this path is the search that came up empty (the escalation link only
    // appears after one). If that context is somehow blank (the link is
    // session-sticky, so a cleared input can precede it), the §18 confirmed
    // heading stands in; the §11 reassurance and micro always render.
    function screenEscalated(rootEl) {
      var c = COPY.notFound;
      var s = flow.state;
      var context = (s.brandContext
        ? s.brandContext.brand + " " + s.modelQuery
        : s.query).trim();
      rootEl.appendChild(el("h2", "lhl-heading", context
        ? formatCopy(c.statement, { "Brand Model": context })
        : COPY.escalation.confirmedHeading));
      rootEl.appendChild(el("p", "lhl-body", c.reassurance));
      rootEl.appendChild(el("p", "lhl-micro", c.micro));
      footer(rootEl, { askUs: false, back: true });
    }

    function screenLoading(rootEl) {
      // Form-submit escalations carry their own loading line; every other
      // visit to this screen is a size lookup and keeps the lookup line.
      rootEl.appendChild(el("p", "lhl-loading",
        flow.state.escalationLoading
          ? COPY.micro.loadingEscalation
          : COPY.micro.loadingLookup));
    }

    // The ONLY add-to-cart control (cards AND the §6 right-size add): a
    // button element for semantics, styled as an uppercase text link like
    // the theme's complementary-products block — never a solid button. The
    // flow's progression buttons stay buttons, and the product page's own
    // native buy button is outside the widget entirely. Adds directly: the
    // §13 safety ack was captured upstream on the email/ack step (all
    // placements) — result screens never re-render the checkbox or gate the
    // add. Busy/added states swap the label.
    function cartLink(variantId, label) {
      var busy = flow.state.cartBusyId === variantId;
      var added = flow.state.cartAddedId === variantId;
      var btn = el("button", "lhl-card-add",
        busy ? COPY.micro.loadingCart : added ? COPY.micro.addedToCart : label);
      btn.type = "button";
      btn.disabled = busy;
      btn.addEventListener("click", function () { flow.addToCart(variantId); });
      return btn;
    }

    // One curated enrichment card — ONE structure for both modes; the mode
    // class on the mount element scales it (compact on PDP, larger on
    // landing). Label is the §21 microformat "[Size] · [Colour]" — never
    // the full product title. cart_variant_id is numeric, server-parsed.
    function productCard(card, addLabel) {
      var wrap = el("div", "lhl-product-card");
      if (card.image_url) {
        var img = el("img", "lhl-card-img");
        img.src = card.image_url;
        img.alt = card.title || "";
        img.loading = "lazy";
        wrap.appendChild(img);
      }
      var displaySize = COPY.sizeDisplay[card.product_type] || card.product_type || "";
      // Two rows: size — price, then colour — add-to-cart (the add link sits
      // right-justified directly under the price).
      var line = el("div", "lhl-card-line");
      var title = el("a", "lhl-product-link lhl-card-title", displaySize || card.handle);
      title.href = config.shopBaseUrl + card.url;
      line.appendChild(title);
      if (card.price) line.appendChild(el("span", "lhl-card-price", "$" + card.price));
      wrap.appendChild(line);
      var row2 = el("div", "lhl-card-line lhl-card-row2");
      if (card.colour_name) {
        row2.appendChild(el("span", "lhl-card-colour", card.colour_name));
      }
      row2.appendChild(cartLink(card.cart_variant_id, addLabel));
      wrap.appendChild(row2);
      return wrap;
    }

    function matchCollectionHref(r) {
      var handle = (r.enrichment && r.enrichment.collection_handle) || r.collection;
      return collectionUrl(handle);
    }

    function seeAllLink(r, displaySize) {
      var seeAll = el("p", "lhl-see-all");
      seeAll.appendChild(link(
        formatCopy(COPY.matchDiscovery.seeAllLink, { Size: displaySize }),
        matchCollectionHref(r)
      ));
      return seeAll;
    }

    // Reassurance line: DATA-DRIVEN — the row's fit_copy (sheet-sourced,
    // served by the API), NEVER the Shopify fit_description metafield (that
    // is PDP-page copy only). Copy Set fallback is a safety net.
    function fitCopyLine(r) {
      return el("p", "lhl-body lhl-fit-copy",
        r.fit_copy || COPY.matchDiscovery.reassuranceFallback);
    }

    // ONE statement builder for §6/§7/§8: weight-600 line with the [Size]
    // token rendered as the brand-green span (a collection link on §8),
    // the rest black; [Brand Model] filled inline.
    function sizeStatement(template, r, sizeEl) {
      var statement = el("h2",
        "lhl-heading lhl-result-match lhl-statement-strong");
      var values = { "Brand Model": r.brand + " " + r.model };
      var parts = template.split("[Size]");
      statement.appendChild(document.createTextNode(formatCopy(parts[0], values)));
      statement.appendChild(sizeEl);
      statement.appendChild(document.createTextNode(formatCopy(parts[1], values)));
      return statement;
    }

    // §6 — PDP, this product is the right size: statement + fit copy ONLY.
    // No add control and no flourish here — the product page's own native
    // buy button handles the add (the copy strings stay in copy.js).
    function matchPdpRight(rootEl, r, pdp, displaySize) {
      rootEl.appendChild(sizeStatement(COPY.matchPdpRight.statement, r,
        el("span", "lhl-size-green", displaySize)));
      renameNote(r, rootEl);
      rootEl.appendChild(fitCopyLine(r));
    }

    // §7 — PDP, wrong size: up to 2 compact in-stock cards (same print
    // resized first, then a recommended-size colour sibling / best seller),
    // otherwise the collection link. Never assume a resize exists.
    function matchPdpWrong(rootEl, r, pdp, displaySize) {
      var c = COPY.matchPdpWrong;
      rootEl.appendChild(sizeStatement(c.statement, r,
        el("span", "lhl-size-green", displaySize)));
      renameNote(r, rootEl);
      // No §13 checkbox here — the ack lives on the email/ack step.
      var cards = ((r.enrichment && r.enrichment.cards) || []).slice(0, 2);
      if (cards.length) {
        // #6: count-aware favourites sentence; "[Size] Collection" renders
        // as an inline link to the RECOMMENDED size's collection
        // (matchCollectionHref — never the current product's), same weight
        // as the sentence, olive via .lhl-collection-inline.
        var template = cards.length === 2 ? c.favouritesTwo : c.favouritesOne;
        var parts = template.split("[Size] Collection");
        var line = el("p", "lhl-sub");
        line.appendChild(document.createTextNode(parts[0]));
        var collectionLink = el("a", "lhl-link lhl-collection-inline",
          displaySize + " Collection");
        collectionLink.href = matchCollectionHref(r);
        line.appendChild(collectionLink);
        line.appendChild(document.createTextNode(parts[1] || ""));
        rootEl.appendChild(line);
        var row = el("div", "lhl-cards");
        cards.forEach(function (card) {
          row.appendChild(productCard(card, COPY.cards.addLink));
        });
        rootEl.appendChild(row);
      } else {
        var shop = el("p", "lhl-see-all");
        shop.appendChild(link(
          formatCopy(c.collectionLink, { Size: displaySize }), matchCollectionHref(r)));
        rootEl.appendChild(shop);
      }
    }

    // §8 — Discovery: answer-first (size statement + collection-linked title,
    // then reassurance), up to 2 in-stock cards, collection link, flourish.
    function matchDiscovery(rootEl, r, displaySize) {
      var c = COPY.matchDiscovery;
      // Unified statement: the [Size] span is green AND a collection link.
      var sizeLink = el("a", "lhl-product-link lhl-size-green", displaySize);
      sizeLink.href = matchCollectionHref(r);
      rootEl.appendChild(sizeStatement(c.statement, r, sizeLink));
      renameNote(r, rootEl);
      rootEl.appendChild(fitCopyLine(r));
      // Cards (max 2, curated in-stock by the API). Sub-copy: resized
      // recently-viewed prints get the "eye on" line; the colour-sibling /
      // best-seller fallback gets the favourites line. (Safety ack §13 was
      // given before the result on this placement.)
      var cards = (r.enrichment && r.enrichment.cards) || [];
      if (cards.length) {
        var fromRecents = cards.some(function (card) {
          return card.source === "resize" || card.source === "recent";
        });
        rootEl.appendChild(el("p", "lhl-sub lhl-cards-sub",
          fromRecents ? c.subRecentlyViewed : c.subBestSellers));
        var row = el("div", "lhl-cards");
        cards.slice(0, 2).forEach(function (card) {
          row.appendChild(productCard(card, COPY.cards.addLink));
        });
        rootEl.appendChild(row);
      }
      rootEl.appendChild(seeAllLink(r, displaySize));
      // (§8 flourish retired from render — the string stays in copy.js.)
    }

    function screenResult(rootEl) {
      var s = flow.state;
      var r = s.result;
      var brandModel = r.brand + " " + r.model;

      if (r.outcome === "MATCH") {
        // Display-only size name (§19): canonical Type stays canonical
        // everywhere else; the customer sees the display form.
        var displaySize = COPY.sizeDisplay[r.size_type] || r.size_type;
        // PDP branches on the mounted product (from the enrichment) — right
        // size (§6) vs wrong size (§7). Without it (enrichment off/failed),
        // the universal Discovery layout (§8) is the safe fallback.
        var pdp = config.placement === "pdp"
          ? (r.enrichment && r.enrichment.pdp_product) : null;
        if (pdp && pdp.product_type === r.size_type) {
          matchPdpRight(rootEl, r, pdp, displaySize);
        } else if (pdp) {
          matchPdpWrong(rootEl, r, pdp, displaySize);
        } else {
          matchDiscovery(rootEl, r, displaySize);
        }
      } else if (r.outcome === "DOESNT_FIT") {
        var d = COPY.doesntFit;
        rootEl.appendChild(el("h2", "lhl-heading",
          formatCopy(d.statement, { "Brand Model": brandModel })));
        renameNote(r, rootEl);
        rootEl.appendChild(el("p", "lhl-body", d.reassurance));
        var talk = el("p", "lhl-talk");
        talk.appendChild(link(d.link, config.contactUrl));
        rootEl.appendChild(talk);
      } else if (r.outcome === "PENDING") {
        var p = COPY.pending;
        rootEl.appendChild(el("h2", "lhl-heading",
          formatCopy(p.statement, { "Brand Model": brandModel })));
        renameNote(r, rootEl);
        rootEl.appendChild(el("p", "lhl-body", p.reassurance));
        rootEl.appendChild(el("p", "lhl-micro", p.micro));
      } else { // NOT_FOUND
        var n = COPY.notFound;
        rootEl.appendChild(el("h2", "lhl-heading",
          formatCopy(n.statement, { "Brand Model": brandModel })));
        rootEl.appendChild(el("p", "lhl-body", n.reassurance));
        rootEl.appendChild(el("p", "lhl-micro", n.micro));
      }
      // Result screens carry only "Start again" (no escalation link here).
      footer(rootEl, { askUs: false, back: true });
    }

    function screenError(rootEl) {
      var c = COPY.error;
      rootEl.appendChild(el("h2", "lhl-heading", c.statement));
      rootEl.appendChild(el("p", "lhl-body", c.reassurance));
      var retry = el("button", "lhl-btn lhl-btn-primary", c.retryButton);
      retry.type = "button";
      retry.addEventListener("click", function () { flow.retry(); });
      rootEl.appendChild(retry);
      var msg = el("a", "lhl-btn lhl-btn-secondary", c.contactButton);
      msg.href = config.contactUrl;
      rootEl.appendChild(msg);
    }

    var SCREENS = {
      welcome: screenWelcome,
      search: screenSearch,
      models: screenModels,
      email: screenEmail,
      loading: screenLoading,
      result: screenResult,
      error: screenError,
      escalate: screenEscalate,
      escalated: screenEscalated,
    };

    // ── KEYSTROKE CONTAINMENT (hardening) ──────────────────────────────
    // The widget binds NO key handlers of its own — typing is native. (The
    // live dead-textarea bug turned out to be a delegated INPUT handler
    // re-rendering per keystroke — see formField — but this boundary stays:
    // a host-page document-level key handler calling preventDefault on a
    // BUBBLED keydown would cancel text insertion even after the event has
    // passed through the field.) Key events that originate in our editable
    // fields stop here at the widget boundary, so no host handler
    // downstream can see or cancel them. (A CAPTURE-phase document handler
    // runs before the event reaches us — no embed can defend against that.)
    ["keydown", "keypress", "keyup"].forEach(function (type) {
      container.addEventListener(type, function (event) {
        var target = event.target;
        var tag = target && target.tagName ? String(target.tagName).toUpperCase() : "";
        if (tag === "INPUT" || tag === "TEXTAREA") {
          event.stopPropagation();
        }
      });
    });

    // Presentation mode — ONE widget, one flow; data-placement picks a mode
    // class on the mount element and mode-scoped CSS does the rest. No
    // duplicated logic anywhere below this line, only layout branching.
    var mode = config.placement === "pdp" ? "pdp" : "discovery";
    if ((container.className || "").indexOf("lhl-mode-") === -1) {
      container.className = (container.className ? container.className + " " : "")
        + "lhl-mode-" + mode;
    }

    // PDP entry row: a single collapsed accordion row (matches the
    // product-detail tabs styling — uppercase via CSS, ruler icon). Click
    // expands the tool inline; the first expand skips the welcome hero
    // straight to Step 1 (§1: PDP goes straight to the brand step).
    var pdpExpanded = false;

    function pdpTabRow() {
      var row = el("button", "lhl-pdp-tab");
      row.type = "button";
      row.setAttribute("aria-expanded", pdpExpanded ? "true" : "false");
      var icon = el("span", "lhl-pdp-icon");
      icon.setAttribute("aria-hidden", "true");
      row.appendChild(icon);
      row.appendChild(el("span", "lhl-pdp-tab-label", COPY.pdpEntry.label));
      row.addEventListener("click", function () {
        pdpExpanded = !pdpExpanded;
        if (pdpExpanded && flow.state.screen === "welcome") {
          flow.start(); // notifies -> render
          return;
        }
        render();
      });
      return row;
    }

    function render() {
      container.innerHTML = "";
      if (mode === "pdp") {
        // Collapsed-state marker: scoped CSS guarantees the collapsed widget
        // is EXACTLY the tab row's height — no theme-inherited margins,
        // padding or min-height reserving an empty band below it. Expanded
        // spacing is untouched (the class is absent then).
        var base = container.className.replace(/ ?lhl-collapsed/g, "");
        container.className = pdpExpanded ? base : base + " lhl-collapsed";
        container.appendChild(pdpTabRow());
        if (!pdpExpanded) return;
      }
      var card = el("div", "lhl-card lhl-screen-" + flow.state.screen);
      SCREENS[flow.state.screen](card);
      container.appendChild(card);
    }

    flow.onChange(render);
    render();
    return flow;
  }

  return {
    mount: mount,
    createFlow: createFlow,
    createApiClient: createApiClient,
    createCartClient: createCartClient,
    DEFAULTS: DEFAULTS,
  };
});


/* Theme auto-mount: every element carrying data-lhl-size-tool mounts itself
   once the DOM is ready (the asset is loaded with `defer`, so this runs
   after parsing either way). Config rides on the element's data- attributes:
   data-api-base, data-placement, data-product-handle, data-shop-base. */
(function () {
  if (typeof document === "undefined" || !document.querySelectorAll) return;
  var root = typeof self !== "undefined" ? self : this;
  function mountAll() {
    var nodes = document.querySelectorAll("[data-lhl-size-tool]");
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].getAttribute("data-lhl-mounted")) {
        nodes[i].setAttribute("data-lhl-mounted", "true");
        root.LHLSizeTool.mount(nodes[i], {});
      }
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAll);
  } else {
    mountAll();
  }
})();
}).call(typeof self !== "undefined" ? self : this);
